import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReceiptSelectSubHeaderComponent } from './receipt-select-sub-header.component';
import { RouterModule } from '@angular/router';
import { StaticMsgModule } from '@lib/pipes';

@NgModule({
  declarations: [ReceiptSelectSubHeaderComponent],
  imports: [CommonModule, RouterModule, StaticMsgModule],
  exports: [ReceiptSelectSubHeaderComponent],
})
export class ReceiptSelectSubHeaderModule {}
